import React from 'react'

const SvgIconEquipment = (props) => (
  <svg viewBox="0 0 44 44" {...props}>
    <path
      d="M43.2.3c-.1-.2-.4-.3-.6-.3-.1 0-1.8.1-4.6.7-4.6 1.1-8.5 3-11 4.3-5 2.8-9.6 6.6-13.7 11.2-3.4 3.9-6.5 8.5-9.2 13.6l-3 3.1c-.3.4-.3.9 0 1.3.2.2.5.3.8.3-.5 1-.9 2.1-1.3 3.1-.3.7.2 1.4 1.2 2.5l.6.6-.6.7c-.3.4-.3.9 0 1.3s.9.4 1.3 0l.6-.7.5.5C5.4 43.8 5.9 44 6.3 44c.1 0 .3 0 .4-.1 1-.4 2-.9 3-1.3 0 .3 0 .6.2.8.3.4.9.4 1.3 0l3-3.1c5-2.7 9.5-5.9 13.3-9.4 4.5-4.2 8.2-8.9 11-14 4.7-8.7 5-15.6 5-15.9 0-.3-.1-.5-.3-.7zM37 16c-2.6 4.9-6.2 9.5-10.6 13.5-5.4 5-12.2 9.2-20 12.6-.3-.2-.9-.7-1.5-1.3l3.2-3.2c.3-.4.3-.9 0-1.3s-.9-.4-1.3 0l-3.2 3.2c-.6-.6-1-1.2-1.3-1.5 3.3-8 7.4-14.9 12.3-20.5 4-4.5 8.4-8.2 13.2-10.9 4.3-2.4 8.1-3.6 10.5-4.2.7-.2 1.2-.3 1.8-.4L10.6 32.4c-.3.4-.3.9 0 1.3.3.3.9.4 1.2 0L41.4 3.4c-.1.6-.2 1.2-.4 1.9-1 4.5-2.7 8.3-4 10.7z"
      fill="currentColor"
    />
  </svg>
)

export default SvgIconEquipment
